<template>
  <v-container>
    <v-card class="mx-auto pl-4" min-width="100%">
      <v-list-item three-line>
        <v-list-item-content>
          <v-list-item-title class="display-1 font-weight-bold">
            CUBIC-Cloud documentation
          </v-list-item-title>
          <template v-if="!loaded">
            <h3 class="mt-5 ml-3 mb-5">
              <v-progress-circular
                class="ml-3"
                indeterminate
                color="primary"
              ></v-progress-circular>
            </h3>
          </template>
          <template v-else-if="errorMessage">
            <div class="mt-5 ml-3">{{ errorMessage }}</div>
          </template>
          <template v-else>
            <div v-for="content in contents" :key="content.title">
              <h2 class="mt-5 ml-3 mb-5">{{ content.title }}</h2>
              <template v-if="trees[content.key]">
                <div v-for="tree in trees[content.key]" :key="tree.PageId">
                  <div v-if="tree.Children.length === 0">
                    <v-btn
                      color="primary"
                      class="text-none ml-6"
                      style="padding-left: 0px;"
                      text
                      dark
                      @click="page_to('/docs/' + tree.Path)"
                    >
                      {{ tree.Title }}
                    </v-btn>
                  </div>
                  <div v-else class="ml-6">
                    <div class="mt-3 mb-3">{{ tree.Title }}</div>
                    <div
                      v-for="treeChildren in tree.Children"
                      :key="treeChildren.PageId"
                    >
                      <v-btn
                        color="primary"
                        class="text-none ml-6"
                        style="padding-left: 0px;"
                        text
                        dark
                        @click="page_to('/docs/' + treeChildren.Path)"
                      >
                        {{ treeChildren.Title }}
                      </v-btn>
                    </div>
                  </div>
                </div>
              </template>
            </div>
          </template>
        </v-list-item-content>
      </v-list-item>
    </v-card>
  </v-container>
</template>

<script>
import {mapState, mapMutations} from 'vuex'

export default {
  title: 'documents',
  components: {},

  data: () => ({
    errorMessage: null,
    contents: [
      {title: 'Tutorial', key: 'tutorial'},
      {title: 'User guide', key: 'user_guide'},
    ],
  }),
  computed: {
    ...mapState({
      trees: (state) => state.docs.trees,
    }),
    loaded: function() {
      return (
        !!this.errorMessage ||
        (!this.is_empty(this.trees['tutorial']) &&
          !this.is_empty(this.trees['user_guide']))
      )
    },
  },
  methods: {
    ...mapMutations({
      setTree: 'docs/setTree',
    }),
  },
  created: function() {
    if (this.is_empty(this.trees['tutorial'])) {
      this.getPageTree('tutorial')
        .then((res) => {
          this.setTree({name: 'tutorial', value: res.data})
        })
        .catch((error) => {
          this.errorMessage = 'Temporary error, please reload the window.'
        })
    }
    if (this.is_empty(this.trees['user_guide'])) {
      this.getPageTree('user_guide')
        .then((res) => {
          this.setTree({name: 'user_guide', value: res.data})
        })
        .catch((error) => {
          this.errorMessage = 'Temporary error, please reload the window.'
        })
    }
  },
}
</script>
